/* eslint-disable */

export const valueSchema = {
  body: {
    type: 'object',
    required: ['id', 'auditTypeId', 'uploaderCompanyId', 'name'],
    additionalProperties: false,
    properties: {
      id: {
        type: 'string',
        minLength: 1,
        maxLength: 36,
      },
      companyId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      companyName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      uploaderCompanyId: {
        type: 'string',
        minLength: 1,
        maxLength: 64,
      },
      uploaderCompanyName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      name: {
        type: 'string',
        minLength: 1,
        maxLength: 255,
      },
      nextPlannedAuditDate: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      referenceNumber: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      facilityScore: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditedBy: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditReportFileId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      correctiveActionPlanFileId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      type: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditTypeId: {
        type: 'string',
        minLength: 1,
        maxLength: 255,
      },
      isPublic: {
        oneOf: [
          {
            type: 'boolean',
          },
          {
            type: 'number',
          },
        ],
      },
      auditTypeName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditDate: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      dataStatus: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      aiActions: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditReportFileUrl: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditReportFileOriginalUrl: {
        type: ['string', 'null'],
        minLength: 1,
      },
      auditReportFileType: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditReportFileContentType: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      auditReportFileBucketName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      extractedData: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      correctiveActionPlanFileUrl: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      correctiveActionPlanFileOriginalUrl: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      correctiveActionPlanFileFileType: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      correctiveActionPlanFileContentType: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      correctiveActionPlanFileBucketName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      permissions: {
        oneOf: [
          {
            type: 'array',
          },
          {
            type: 'null',
          },
        ],
      },
      privacyStatus: {
        oneOf: [
          {
            type: 'object',
          },
          {
            type: 'null',
          },
        ],
      },
      profileType: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedAt: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByImpersonateId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByImpersonateName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByUserId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByUserName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByCompanyId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByCompanyName: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByApiKeyId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      updatedByApiKeyLabel: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      createdAt: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      createdByImpersonateId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      createdByUserId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      createdByCompanyId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      createdByApiKeyId: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      createdByApiKeyLabel: {
        oneOf: [
          {
            type: 'string',
          },
          {
            type: 'null',
          },
        ],
      },
      findings: {
        oneOf: [
          {
            type: 'array',
            items: {
              type: 'object',
              required: ['auditId', 'title'],
              additionalProperties: true,
              properties: {
                id: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 36,
                },
                auditId: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 36,
                },
                companyId: {
                  type: 'string',
                  minLength: 1,
                  maxLength: 36,
                },
                title: {
                  type: 'string',
                  minLength: 1,
                },
                impactAreaId: {
                  oneOf: [
                    {
                      type: 'string',
                      minLength: 1,
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
                description: {
                  oneOf: [
                    {
                      type: 'string',
                      minLength: 1,
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
                urgency: {
                  oneOf: [
                    {
                      type: 'string',
                      minLength: 1,
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
                source: {
                  oneOf: [
                    {
                      type: 'string',
                      minLength: 1,
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
                isRemoved: {
                  oneOf: [
                    {
                      type: 'number',
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
                suggestedActions: {
                  oneOf: [
                    {
                      type: 'array',
                      items: {
                        type: 'string',
                      },
                    },
                    {
                      type: 'null',
                    },
                  ],
                },
              },
            },
          },
          {
            type: 'null',
          },
        ],
      },
    },
  },
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    audit_higg_fslm_higg_facility_social_labor_module: valueSchema,
  },
}
